import {defineStore} from 'pinia';
import {dashboardService} from '../services/dashboard-service';

export const useDashboardStore = defineStore('dashboard-store', {
    state: () => ({
        dashboard: null,
        loading: false,
        error: null,
    }),

    getters: {
        assignments: (state) => state.dashboard?.assignments || [],
        collector: (state) => state.dashboard?.user || {},
        pay: (state) => state.dashboard?.pay || {},
        adminStats: (state) => state.dashboard?.admin_stats || null,
    },

    actions: {
        async boot() {
            this.loading = true;
            this.error = null;
            try {
                const {data} = await dashboardService.getDashboard();
                this.dashboard = data;
            } catch (e) {
                this.error = e;
                throw e;
            } finally {
                this.loading = false;
            }
        },

        async refresh() {
            try {
                const {data} = await dashboardService.getDashboard();
                this.dashboard = data;
            } catch {
                // Silently fail on background refresh — stale data is fine
            }
        },
    },
});
